<!--
    @name: 工友管理
    @description:  工友管理按钮入口和相关弹窗
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-10-27 15:12:41
-->
<template>
  <span>
    <el-button style="margin-left: 10px" :class="isBzjz?'buttons':''" type="primary"
               @click="showList=true">工友管理</el-button>
    <!--  列表弹窗  -->
    <el-dialog title="工友管理"
               width="800px"
               :append-to-body="true"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="showList"
               :style="isBzjz?'left':'center'"
               :before-close="closeend"
               >
      <div>
        <div style="margin-bottom: 20px">
          <el-input v-model="conditionText"
                    placeholder="请输入姓名或者电话号码"
                    style="width:322px;margin-right: 20px"></el-input>
          <el-button type="primary" :class="isBzjz?'checkbutton':''"
                     @click="getList">搜索</el-button>
          <el-button type="primary" :class="isBzjz?'checkbutton':''"
                     style="margin-left: 20px"
                     @click="$refs.WorkerEdit.open()">新增工友</el-button>
        </div>
        <el-table :cell-style="{height:'44px',padding:'0'}"
                  :data="list"
                  border
                  header-row-class-name="header">
          <el-table-column label="姓名"
                           :width="isBzjz?'259px':'100PX'"
                           prop="name">
          </el-table-column>
          <el-table-column label="电话"
                           :width="isBzjz?'250px':'200PX'"
                           prop="phone">
                           <template slot-scope="scope">
          <span>{{ scope.row.phone?scope.row.phone:'/' }}</span>
        </template>
          </el-table-column> 
          <el-table-column v-if="!isBzjz" label="工资标准"
                           prop="salaryStandardVo">
            <template slot-scope="{row}">
              {{toMoney(row)}}
            </template>
          </el-table-column>
          <el-table-column label="操作" :width="isBzjz?'250px':'120PX'">
            <template slot-scope="scope">
              <el-button size="small"
                         type="text"
                         style="color:#0286df"
                         @click="$refs.WorkerEdit.open(scope.row)">编辑</el-button>
              <el-button size="small"
                         style="color: #FF6600;margin-left: 20px"
                         type="text"
                         v-if="!(seach&&param.page==1&&scope.$index==0)"
                         @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <page
          v-if="param.total&&!loading"
          :loadingTrue="loading"
          :param="param"
          @change="getList(false)"
          style="margin-top: 18px"
        ></page>
      </div>
    </el-dialog>
    <WorkerEdit ref="WorkerEdit" 
                @editend="getList(true)"></WorkerEdit>
    <WorkerEditTeam ref="WorkerEdit" v-if="isBzjz"
                @editend="getList(true)"></WorkerEditTeam>
  </span>
</template>

<script>
import {api} from '@/api/apiRecord.js'

export default {
  name: "workerManagement",
  components: {
    page: () => import("@/components/card/page"),
    WorkerEdit: () => import("./WorkerEdit"),
    WorkerEditTeam: () => import("./WorkerEditTeam"),
  },
  data() {
    return {
      showList: false,
      list: [],
      conditionText:'',//搜索字段
      loading: false,
      param: {
        page: 1,
        limit: 10,
        total: 0,
      },
      delform: {},
      type:this.$route.query.type?this.$route.query.type:1,//当前页面进入模式1.个人记工2.班组记工
      seach:false,//是否为搜索状态
    }
  },
    props:{
      isBzjz: {
      type: [Boolean],
      default: false
    }
  },
  watch: {
    showList(v) {
      if (v) {
        this.conditionText=''
        this.getList(false)
      }
    }
  },
  methods: {
    //项目列表
    async getList(end=false) {
      if(end){
        this.$emit('end',true)
      }
      this.loading = true
      this.seach=this.conditionText==''
      let res = await api.settleWorkerPage({...this.param,type:this.type,conditionText:this.conditionText})
      this.loading = false
      if (res.data.code == 200) {
        this.list = res.data.data.records
        this.param.total = res.data.data.total;
        if(this.seach&&!this.list.length&&!res.data.data.total){
          //接口报错还没改
          await api.settleWorkerAddMy(this.type)
          this.getList();
        }
      }
    },
    //删除项目
    del(data) {
      this.$message.tips('确定删除该工友吗？', (v) => {
        if (v) {
          this.delform = data;
          this.senddel();
        }
      })
    },
    async senddel() {
      let no = this.delform.no
      let res = await api.settleWorkeDel(no)
      if (res.data.code == 200) {
        this.$message.success(res.data.msg)
        let totalPage=Math.ceil((this.param.total-1)/10)
        let currentPage=this.param.page>totalPage?totalPage:this.param.page
        this.param.page=currentPage<1?1:currentPage
        this.getList(true)
      } else {
        if (res.data.msg.indexOf('开发') > -1) {
          this.$message.kfz(res.data.msg)
        }
      }
    },
    closeend(no) {
      this.showList = false
      this.$emit('close')
    },
    toMoney({salaryStandardVo}){
      let str=[];
      if(!salaryStandardVo){
       return ''
      }
      if(salaryStandardVo.workStandardSalary){
        str.push(`上班${salaryStandardVo.workStandardSalary}元/工`)
      }
      if(salaryStandardVo.workOvertimeType==2){//==2 按小时算加班
        if(salaryStandardVo.workOvertimeSalary){
          str.push(`加班${salaryStandardVo.workOvertimeSalary}元/小时`)
        }
      }else{// ==1 按工天算加班
        if(salaryStandardVo.workOvertimeStandard&&salaryStandardVo.workStandardSalary){
          str.push(`加班${(salaryStandardVo.workStandardSalary/salaryStandardVo.workOvertimeStandard).toFixed(2)}元/小时`)
        }
      }

      return str.join()
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
  height: 44px;
  line-height: 44px;
  padding:0 20px!important;
}
/deep/.el-dialog__headerbtn {
    top: 12px;
}
/deep/.el-dialog__title {
  line-height: 44px;
  color: #000;
}
/deep/.el-input__inner{
  height: 34px;
  line-height: 34px;
}
/deep/.buttons{
  color: #fff !important;
  background: #B79255 !important;
  border-color:#B79255 !important;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
  border-radius: 0;
}
/deep/.checkbutton{
  color: #fff !important;
  background: #B79255!important;
  border-color:#B79255 !important;
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
}
/deep/ .header .el-table__cell {
  background: #FAFAFA;
  padding: 0;
  height: 44px;
}

/deep/ .el-dialog__body {
  padding: 20px;
}

/deep/ .el-button--small {
  font-size: 14px;
}
.el-button--primary {
    color: #B79255;
    border-color: #B79255;
    background: #fff;
    &:hover{
      color: #B79255;
      border-color: #B79255;
      background: #fff;
    }
  }
</style>
